type RecordLike = Record<string, any>;

export const getUniqueOptionsFromField = <
  T extends RecordLike,
  K extends keyof T,
>({
  data,
  field,
}: {
  data: T[];
  field: K;
}): { label: string; value: string }[] => {
  const uniqueValues = [
    ...new Set(
      data
        .map((record) => record[field] as unknown)
        .filter((value): value is string => typeof value === "string")
        .filter((value) => value.trim().length > 0),
    ),
  ];

  return uniqueValues.map((value) => ({
    label: value,
    value,
  }));
};

export const getNextSequentialId = <T extends RecordLike, K extends keyof T>({
  data,
  idField,
  prefix,
  padLength = 6,
}: {
  data: T[];
  idField: K;
  prefix: string;
  padLength?: number;
}) => {
  const ids = data
    .map((record) => record[idField] as unknown)
    .filter((value): value is string => typeof value === "string")
    .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));

  const largestId = ids[ids.length - 1];
  const nextNumber = largestId
    ? parseInt(largestId.slice(prefix.length), 10) + 1
    : 1;

  return `${prefix}${nextNumber.toString().padStart(padLength, "0")}`;
};
